const apiProxyWhitelist = [{
  regex: new RegExp('coaching-tips/v1/status/.*'),
  methods: ['GET', 'DELETE']
}, {
  regex: new RegExp('coaching-tips/v1/status'),
  methods: ['POST']
}];
export default apiProxyWhitelist;